// docs: https://github.com/altostra/type-validations#readme
import { objectOf /*, maybe */ } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

import type { GetLandingPagesCustomDomainLimitsResult } from "./types";

export const isGetLandingPagesCustomDomainLimitsResult = objectOf<GetLandingPagesCustomDomainLimitsResult>({
  company_custom_domain_limit: number,
  company_custom_domain_count: number,
});
